(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('TypeAssociationDetailController', TypeAssociationDetailController);

    TypeAssociationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TypeAssociation'];

    function TypeAssociationDetailController($scope, $rootScope, $stateParams, previousState, entity, TypeAssociation) {
        var vm = this;

        vm.typeAssociation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:typeAssociationUpdate', function(event, result) {
            vm.typeAssociation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
